import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from 'src/app/components/Sidebar/Sidebar.module.scss';
import {
  subItem,
  activeSubItem,
  allPPMReadPermissions,
  allODC2MReadPermissions,
  allOMMPermissions,
  allFMMPermissions,
  allRLSMPermissions,
  allExperimentationPermissions,
  allLILLPermissions,
  allSSMPermissions,
  allPPMPermissions,
  allODC2MPermissions,
  allCOAMReadPermissions,
  collapsedMenu,
  allCOAMPermissions,
} from 'src/app/components/Sidebar/sidebar.config';
import { Module } from 'src/enums/module.enum';

import { eventService } from 'src/app/services';

import { useHistory } from 'react-router-dom';
import { routeHelper } from 'src/app/helpers';
import { reduxRootTypes } from 'src/types';
import { pageActions } from 'src/app/redux/actions';
import { useCollapsedContext } from 'src/app/layouts/Default/LayoutDefault';
const { Item } = Menu;

import { LuKanbanSquare } from 'react-icons/lu';
import { BiSolidHide, BiSolidShow } from 'react-icons/bi';
import { LiaMapSignsSolid } from 'react-icons/lia';
import { useTranslation } from 'react-i18next';
import i18n from 'src/i18n';
import { ArrowLeftOutlined, ArrowRightOutlined, MenuFoldOutlined } from '@ant-design/icons';
import Menu from 'antd/es/menu';

const Sidebar = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const { collapsed, setCollapsed } = useCollapsedContext();

  const [activeItem, setActiveItem] = useState('ADMINISTRATION');

  const pageState = useSelector((state: reduxRootTypes.RootStateType) => state.pageState);
  const userState = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { eventId, eventList } = useSelector((state: reduxRootTypes.RootStateType) => state.eventState);
  const { localpermissions } = useSelector((state: reduxRootTypes.RootStateType) => state.userRolePermissionState);

  useEffect(() => {
    setActiveItem(pageState.activePage);
  }, [pageState.activePage]);

  useEffect(() => {
    setActiveItem(history.location.pathname.substring(1).toUpperCase());
  }, []);

  const handleDbClick = () => {
    setCollapsed(!collapsed);
  };

  const handleClick = (page: number | string) => {
    if (typeof page === 'string') {
      setActiveItem(page.toUpperCase());
      dispatch(pageActions.setActivePage(page.toUpperCase()));
      switch (page) {
        // case 'ontology':
        //   dispatch(playerActions.setPlayerId(0));
        //   dispatch(pageActions.setActivePage('ONTOLOGY'));
        //   routeHelper.handleRoute(history, '/Ontology');
        //   break;
        case 'ObjectiveManagement':
          // dispatch(pageActions.setActivePage('OMM MODULE'));
          routeHelper.handleRoute(history, '/ObjectiveManagement');
          break;
        case 'FlowManagement':
          // dispatch(pageActions.setActivePage('FLOW MANAGEMENT MODULE'));
          routeHelper.handleRoute(history, '/FlowManagement');
          break;
        case 'RealLifeSupport':
          // dispatch(pageActions.setActivePage('REAL LIFE SUPPORT MODULE'));
          routeHelper.handleRoute(history, '/RealLifeSupport');
          break;
        case 'Experimentation':
          // dispatch(pageActions.setActivePage('EMM MODULE'));
          routeHelper.handleRoute(history, '/Experimentation');
          break;
        case 'database':
          // dispatch(pageActions.setActivePage('DATABASE'));
          routeHelper.handleRoute(history, '/Database');
          break;
        case 'Lill':
          // dispatch(pageActions.setActivePage('LILL'));
          routeHelper.handleRoute(history, '/Lill');
          break;
        case 'administration':
          // dispatch(pageActions.setActivePage('ADMINISTRATION'));
          routeHelper.handleRoute(history, '/Administration');
          break;
        case 'resource module':
          // dispatch(pageActions.setActivePage('RESOURCE MODULE'));
          routeHelper.handleRoute(history, '/Resource');
          break;
        case 'SSM':
          // dispatch(pageActions.setActivePage('SSM'));
          routeHelper.handleRoute(history, '/SSM');
          break;
        case 'PPM':
          // dispatch(pageActions.setActivePage('PPM'));
          routeHelper.handleRoute(history, '/PPM');
          break;
        case 'ODC2M':
          // dispatch(pageActions.setActivePage('PPM'));
          routeHelper.handleRoute(history, '/ODC2M');
          break;
        case 'coam':
          routeHelper.handleRoute(history, '/COAM');
          break;
        default:
          break;
      }
    }
  };

  const [disabledItems, setDisabledItems] = useState<Record<string, boolean>>({
    ObjectiveManagement: false,
    FlowManagement: false,
    RealLifeSupport: false,
    Experimentation: false,
    Lill: false,
    SSM: false,
    PPM: false,
    ODC2M: false,
  });

  useEffect(() => {
    eventList[0]?.forbiddenModules?.forEach((module) => {
      const moduleName = Object.keys(Module).find((key) => Module[key as keyof typeof Module] === module);
      if (moduleName) {
        setDisabledItems((prev) => ({ ...prev, [moduleName]: true }));
      }
    });
  }, [eventList]);

  const toggleItem = async (event: React.MouseEvent, key: string, permissions: number[]) => {
    event.stopPropagation();
    const newDisabledState = !disabledItems[key];

    if (newDisabledState) {
      await eventService.updateForbiddenModule({
        addModule: Module[key as keyof typeof Module],
        permissions: permissions,
      });
    } else {
      await eventService.updateForbiddenModule({
        deleteModule: Module[key as keyof typeof Module],
        permissions: [],
      });
    }

    setDisabledItems((prev) => ({ ...prev, [key]: newDisabledState }));
  };

  const getItemStyle = (key: string) => ({
    ...((activeItem.toLowerCase() === key.toLowerCase() ? activeSubItem : subItem) as React.CSSProperties),
    opacity: disabledItems[key.toUpperCase()] ? 0.5 : 1,
    transition: 'opacity 0.3s ease',
  });

  const getSideBarWidth = () => {
    if (i18n.dir() === 'rtl') {
      return 'auto';
    } else {
      return 310;
    }
  };

  return (
    <>
      {userState.userRoles.length > 0 && userState.userRoles[0].id && (
        <>
          <div className="map-sidebar-container">
            {eventId !== '' && (
              <>
                <Menu
                  inlineCollapsed={collapsed}
                  theme="light"
                  className={styles.mapSidebar}
                  style={{
                    width: collapsed ? 20 : getSideBarWidth(),
                    background: 'var(--secondary-color)',
                  }}
                  mode="inline"
                  onClick={(e) => handleClick(e.key)}
                  onDoubleClick={(_) => handleDbClick()}
                >
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find((permission) => permission === 11001 || permission === 18001) && (
                      <Item
                        key="ObjectiveManagement"
                        style={{
                          ...getItemStyle('OMM'),
                          ...(activeItem.toLowerCase() === 'objectivemanagement' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/omm_2x.png"
                            alt="objective management module"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.objective')}
                          {userState.userName === 'Root' &&
                            (disabledItems['OMM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'OMM', allOMMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'OMM', allOMMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find(
                      (permission) =>
                        permission === 5001 ||
                        permission === 6001 ||
                        permission === 7001 ||
                        permission === 8001 ||
                        permission === 9001 ||
                        permission === 10001 ||
                        permission === 19001 ||
                        permission === 20001 ||
                        permission === 35001 ||
                        permission === 36001,
                    ) && (
                      <Item
                        key="FlowManagement"
                        style={{
                          ...getItemStyle('FMM'),
                          ...(activeItem.toLowerCase() === 'flowmanagement' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/fmm_1.png"
                            alt="flow management module"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.flow')}
                          {userState.userName === 'Root' &&
                            (disabledItems['FMM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'FMM', allFMMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'FMM', allFMMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find(
                      (permission) =>
                        permission === 15001 ||
                        permission === 16001 ||
                        permission === 23001 ||
                        permission === 39001 ||
                        permission === 40001,
                    ) && (
                      <Item
                        key="RealLifeSupport"
                        style={{
                          ...getItemStyle('RLSM'),
                          ...(activeItem.toLowerCase() === 'reallifesupport' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/rlsm_1.png"
                            alt="real life support module"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.realLifeSupport')}
                          {userState.userName === 'Root' &&
                            (disabledItems['RLSM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'RLSM', allRLSMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'RLSM', allRLSMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find((permission) => permission === 17001 || permission === 34001) && (
                      <Item
                        key="Experimentation"
                        style={{
                          ...getItemStyle('EMM'),
                          ...(activeItem.toLowerCase() === 'experimentation' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/emm_1.png"
                            alt="experimentation module"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.experimentation')}
                          {userState.userName === 'Root' &&
                            (disabledItems['EMM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'EMM', allExperimentationPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'EMM', allExperimentationPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find((permission) => permission === 21001) && (
                      <Item
                        key="Lill"
                        style={{
                          ...getItemStyle('Lill'),
                          ...(activeItem.toLowerCase() === 'lill' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/lill_1.png"
                            alt="lill"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.lessons')}
                          {userState.userName === 'Root' &&
                            (disabledItems['LILL'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'LILL', allLILLPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'LILL', allLILLPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find(
                      (permission) => permission === 25001 || permission === 26001 || permission === 27001,
                    ) && (
                      <Item
                        key="SSM"
                        style={{
                          ...getItemStyle('SSM'),
                          ...(activeItem.toLowerCase() === 'ssm' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/ssm_1.png"
                            alt="ssm"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.scenarioSettings')}
                          {userState.userName === 'Root' &&
                            (disabledItems['SSM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'SSM', allSSMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'SSM', allSSMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find((permission) => allPPMReadPermissions.includes(permission)) && (
                      <Item
                        style={{
                          ...getItemStyle('PPM'),
                          ...(activeItem.toLowerCase() === 'ppm' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        key="PPM"
                        icon={
                          <LuKanbanSquare
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            style={{ width: 18, height: 18 }}
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.planningProgramming')}
                          {userState.userName === 'Root' &&
                            (disabledItems['PPM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'PPM', allPPMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'PPM', allPPMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find((permission) => allCOAMReadPermissions.includes(permission)) && (
                      <Item
                        style={{
                          ...getItemStyle('COAM'),
                          ...(activeItem.toLowerCase() === 'coam' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        key="coam"
                        icon={
                          <LiaMapSignsSolid
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            style={{ width: 20, height: 20 }}
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.courseOfAction')}
                          {userState.userName === 'Root' &&
                            (disabledItems['COAM'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'COAM', allCOAMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'COAM', allCOAMPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find((permission) => allODC2MReadPermissions.includes(permission)) && (
                      <Item
                        style={{
                          ...getItemStyle('ODC2M'),
                          ...(activeItem.toLowerCase() === 'odc2m' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        key="ODC2M"
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/operationalDesign.png"
                            alt="odc2m"
                          />
                        }
                      >
                        <div className={styles.sidebarItem}>
                          {t('sidebar.operationalDesign')}
                          {userState.userName === 'Root' &&
                            (disabledItems['ODC2M'] ? (
                              <BiSolidShow
                                onClick={(event) => toggleItem(event, 'ODC2M', allODC2MPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ) : (
                              <BiSolidHide
                                onClick={(event) => toggleItem(event, 'ODC2M', allODC2MPermissions)}
                                className={styles.showAndHideIcon}
                              />
                            ))}
                        </div>
                      </Item>
                    )}
                  {userState.userRoles[0].id !== undefined &&
                    localpermissions.find(
                      (permission) =>
                        permission === 1001 || permission === 2001 || permission === 3001 || permission === 4001,
                    ) && (
                      <Item
                        style={{
                          ...(activeItem.toLowerCase() === 'administration' ? activeSubItem : subItem),
                          ...(collapsed ? collapsedMenu : ''),
                        }}
                        key="administration"
                        icon={
                          <img
                            className={!collapsed ? styles.sidebarIcon : styles.sidebarIconWhenBarClosed}
                            src="/assets/administrationIcon.png"
                            alt="administration"
                          />
                        }
                      >
                        {t('sidebar.administration')}
                      </Item>
                    )}
                </Menu>

                {i18n.dir() === 'ltr' ? (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'end',
                      height: 70,
                      background: '#252526',
                    }}
                    onDoubleClick={(_) => handleDbClick()}
                  >
                    {collapsed ? (
                      <ArrowRightOutlined className={styles.arrowRightMove} onClick={(_) => handleDbClick()} />
                    ) : (
                      <ArrowLeftOutlined className={styles.arrowLeftMove} onClick={(_) => handleDbClick()} />
                    )}
                  </div>
                ) : (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'end',
                      height: 70,
                      background: '#252526',
                    }}
                    onDoubleClick={(_) => handleDbClick()}
                  >
                    {collapsed ? (
                      <ArrowLeftOutlined className={styles.arrowLeftMove} onClick={(_) => handleDbClick()} />
                    ) : (
                      <ArrowRightOutlined className={styles.arrowRightMove} onClick={(_) => handleDbClick()} />
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Sidebar;
